import script from "./BankingOposView.vue?vue&type=script&setup=true&lang=js"
export * from "./BankingOposView.vue?vue&type=script&setup=true&lang=js"

import "./BankingOposView.vue?vue&type=style&index=0&id=0053c6d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0053c6d4"]])

export default __exports__